import { vyDate } from '@vy/utils';

export function getContractEndDate(contractStartDate: string, durationInMonths: number) {
  return vyDate(contractStartDate)
    .add(durationInMonths, 'month')
    .subtract(1, 'day')
    .endOf('day')
    .toISOString();
}
